import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mtn-partner-attribution-container',
  templateUrl: './partner-attribution-container.component.html',
  styleUrls: ['./partner-attribution-container.component.scss']
})
export class PartnerAttributionContainerComponent {

  constructor() {
  }


}
